import { createContext, useContext, useEffect, useState } from "react";
import { api, STATIC_MODE } from "@/lib/site";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=unknown, false=not-auth, object=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (STATIC_MODE) {
      setUser(false);
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("res_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("res_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    if (STATIC_MODE) {
      throw new Error("Admin dashboard is not available on the static site. Deploy the backend (Render/Railway) to enable it.");
    }
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("res_token", res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("res_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
